import { useMemo } from 'react'

import { userClaimIds } from '../../../utils/userClaims'
import { useAuth } from './useAuth'

export interface UseCustomerDisplayNameProps {
  familyNameFirst?: boolean
}

function useCustomerDisplayName({ familyNameFirst = false }: UseCustomerDisplayNameProps = {}):
  | string
  | undefined {
  const { user } = useAuth()
  return useMemo(() => {
    if (!user) return undefined

    const {
      [userClaimIds.companyName]: companyName,
      given_name: givenName,
      family_name: familyName,
      name,
    } = user

    if (companyName) return companyName
    if (givenName) {
      // display family name if populated and different from given name
      return familyName && familyName !== givenName
        ? familyNameFirst
          ? `${familyName}, ${givenName}`
          : `${givenName} ${familyName}`
        : givenName
    }
    return name
  }, [familyNameFirst, user])
}

export default useCustomerDisplayName
